import styled, { keyframes } from "styled-components";

const baseColor = "#F4F4F4";
const shineColor = "rgba(229,229,229,0.8)";
const animationDuration = "2s";

const shineAnimation = keyframes`
  0% { background-position: -100px; }
  40%, 100% { background-position: 140px; }
`;

export const StyledSkeletonTable = styled.table`
  border-collapse: collapse;
  border-spacing: 0;
  border-color: #ccc;
  width: 100%;

    th:first-child {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
    }

    th:last-child {
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
    }
`;

export const Th = styled.th`
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: normal;
  padding: 10px 16px;
  border-style: solid;
  border-width: 0;
  overflow: hidden;
  word-break: normal;
  border-color: #ccc;
  color: #333;
  background-color: #f0f0f0;
`;

export const Td = styled.td`
  font-family: Arial, sans-serif;
  font-size: 14px;
  padding: 17px 16px;
  border-style: solid;
  border-width: 0;
  overflow: hidden;
  word-break: normal;
  border-color: #ccc;
  color: #333;
  background-color: #fff;
`;

export const Line = styled.div`
  float: left;
  width: 100%;
  height: 16px;
  border-radius: 7px;
  background-image: linear-gradient(90deg, ${baseColor} 0px, ${shineColor} 40px, ${baseColor} 80px);
  background-size: 600px;
  animation: ${shineAnimation} ${animationDuration} infinite ease-out;
`;
